import React from 'react';
import { CollaboratorsQueryParams } from '../hooks/useCollaboratorParams';
import { Box, Button, Flex } from '@chakra-ui/react';
import { RoleValidator } from '../../../components/RoleValidator';
import { Link } from 'react-router-dom';
import { MerchantBranchSelector } from '../../../components/MerchantBranchSelector';
import { Selector } from '../../../components/Selector';
import { Role, RoleToString } from '../../../domain/Role';

const FILTERABLE_ROLES = [Role.collaborator, Role.branch_owner, Role.auditor];

interface CollaboratorFiltersProps {
  onUpdate: (key: keyof CollaboratorsQueryParams, value?: string) => void;
  queryParams?: CollaboratorsQueryParams;
}

export const CollaboratorFilters = (props: CollaboratorFiltersProps) => {
  const { onUpdate, queryParams } = props;

  return (
    <Flex
      flexWrap="wrap"
      rowGap="s"
      borderBottom="1px"
      borderBottomColor="neutral.300"
      paddingY="l"
      marginBottom="xl"
    >

      <MerchantBranchSelector idMerchant={queryParams?.idMerchant} idBranch={queryParams?.idBranch} handleUpdate={onUpdate} />

      <Selector
        isMulti={true}
        options={FILTERABLE_ROLES.map(role => ({ value: role, label: RoleToString(role) }))}
        onChange={(option) => onUpdate('userRole', option)}
        placeholder="Roles"
        value={queryParams?.userRole}
        marginX="l"
        minWidth="15em"
      />

      <RoleValidator allowedRoles={[Role.branch_owner]}>
        <Box marginLeft="auto">
          <Link to="add">
            <Button colorScheme="button-primary">Agregar colaborador</Button>
          </Link>
        </Box>
      </RoleValidator>

    </Flex>);
};
